import { render, staticRenderFns } from "./TipBoard.vue?vue&type=template&id=d8a2a542&scoped=true"
import script from "./TipBoard.vue?vue&type=script&lang=js"
export * from "./TipBoard.vue?vue&type=script&lang=js"
import style0 from "./TipBoard.vue?vue&type=style&index=0&id=d8a2a542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a2a542",
  null
  
)

export default component.exports